import { render, staticRenderFns } from "./TournamentTopBanner.vue?vue&type=template&id=f8e7eafa&scoped=true"
import script from "./TournamentTopBanner.vue?vue&type=script&lang=js"
export * from "./TournamentTopBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e7eafa",
  null
  
)

export default component.exports